module.exports = __webpack_public_path__ + "static/media/2.Book Jacket.11f15b9a.jpg";